









































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Department } from '@/models/admin/department';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getDepartmentListHeaders } from '@/views/admin/department/department';
import { dealService, departmentService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class DealBlockListPage extends Base {
  public headers: VHeaders[] = [];
  public pagedBlocks: any[] = [];
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public storeId: number;
  public actions: any[] = [];
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('departments.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.deleteBlock();
    },
  };
  public blockToDelete: any = {
    id: '',
    storeId: 0,
    blockName: '',
    sequenceNumber: 0,
    totalTitle: '',
    isRootValue: false,
  };
  public preventPaginationCall: boolean = false;

  public setHeaders() {
    this.headers = [
      {
        text: 'Block Name',
        align: 'left',
        value: 'blockName',
        sortable: true,
      },
      {
        text: 'Sequence Number',
        align: 'left',
        value: 'sequenceNumber',
        sortable: true,
      },
      {
        text: 'Action',
        isNotDataProp: true,
        align: 'center',
        sortable: false,
      },
    ];
  }

  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-eye',
        title: 'View Block',
        action: (model: any, storeId: string) => {
          return {
            name: 'admin.dealaccounts.dealrecap.blocks',
            params: { storeId: this.storeId, id: model.id },
          };
        },
      },
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: 'Edit Block',
        action: (model: any, storeId: string) => {
          return {
            name: 'admin.dealaccounts.dealrecap.edit',
            params: { storeId: this.storeId, id: model.id },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: 'Delete Block',
        color: 'error',
        action: (model: any, storeId: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public created() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = this.userSession.storeId;
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addDealBlock') {
      this.$router.push({
        name: 'admin.dealaccounts.dealrecap.add',
        params: { storeId: this.storeId.toString(), id: '' },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: 'Add Block',
      disabled: false,
      visible: true,
      class: 'btn',
      label: 'Add Block',
      click: 'addDealBlock',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'dealRecap');
    
    this.setHeaders();
    // if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
    this.getDealBlocks(this.storeId);
    // }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
  }

  public async getDealBlocks(storeId: number): Promise<void> {
    try {
      this.loading = true;
      const departments = await dealService.getDealBlocks(
        storeId,
        this.pagination
      );
      this.pagedBlocks = departments.results;
      this.pagination.totalItems = departments.total;
    } finally {
      this.loading = false;
    }
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public confirmDelete(item: any): void {
    this.deleteDialog.model = true;
    this.blockToDelete = item;
  }

  public async deleteBlock(): Promise<void> {
    try {
      await dealService.deleteBlockAsync(this.blockToDelete.id, this.storeId);
      this.preventPaginationCall = true;
      this.showAlert(true, 'Block Deleted Successfully');
      this.getDealBlocks(this.storeId);
    } catch (e) {
      console.log(e);
    } finally {
      this.deleteDialog.model = false;
    }
  }

  public updateStore(storeId: number): void {
    this.storeId = storeId;
    this.getDealBlocks(this.storeId);
  }
}
